// const api_url = 'http://localhost:4000/api/bernoulli/';
const api_url = 'https://api.bernoullirisk.com/api/bernoulli/';
 
module.exports = {
    api_url
}